"use strict";
/* tslint:disable */
/* eslint-disable */
/**
 * TPC Enrollment
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1
 *
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.ServiceLineItemToJSON = exports.ServiceLineItemFromJSONTyped = exports.ServiceLineItemFromJSON = void 0;
const runtime_1 = require("../runtime");
function ServiceLineItemFromJSON(json) {
    return ServiceLineItemFromJSONTyped(json, false);
}
exports.ServiceLineItemFromJSON = ServiceLineItemFromJSON;
function ServiceLineItemFromJSONTyped(json, ignoreDiscriminator) {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        'key': json['key'],
        'description': !runtime_1.exists(json, 'description') ? undefined : json['description'],
        'price': json['price'],
    };
}
exports.ServiceLineItemFromJSONTyped = ServiceLineItemFromJSONTyped;
function ServiceLineItemToJSON(value) {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        'key': value.key,
        'description': value.description,
        'price': value.price,
    };
}
exports.ServiceLineItemToJSON = ServiceLineItemToJSON;
//# sourceMappingURL=ServiceLineItem.js.map